/* 🤖 this file was generated by svg-to-ts */
export const emperorIconNetworkComputer: {
  name: 'network_computer';
  data: string;
} = {
  name: 'network_computer',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M22 8.002H8c-1.104 0-2 .89-2 2v9c0 1.1.89 2 2 2h6v1h-3v2h8v-2h-3v-1h6c1.1 0 2-.9 2-2v-9c0-1.11-.9-2-2-2Zm0 2l-.01 5h-14v-5h14ZM8 19v-2h13.99l-.01 2h-14Z"/><path d="M2 10h2.99v2h-3Z"/><path d="M2 2.002h8v5h2V1c0-.553-.45-1-1-1H1C.44 0 0 .44 0 1v7c0 .55.447 1 1 1h3.99V7h-3V2Z"/></g></svg>`,
};
